import {
	createFileRoute,
	Outlet,
	useRouteContext,
} from "@tanstack/react-router";
import { Image } from "@/components/image";

export const Route = createFileRoute("/_auth")({
	component: RouteComponent,
});

function RouteComponent() {
	const { club } = useRouteContext({ from: "__root__" });

	return (
		<div className="flex flex-row h-full md:overflow-y-auto md:max-h-screen">
			<div className="flex-1 p-6 lg:flex lg:items-center lg:justify-center">
				<Outlet />
			</div>

			<div className="flex-1 bg-primary/10 font-semibold flex-col gap-6 h-screen sticky max-md:hidden top-0 flex items-center justify-center">
				<Image
					src={club.logo?.signedUrl || ""}
					width={800}
					className="size-24 rounded-full"
				/>

				<h3 className="text-2xl/6">{club.name}</h3>
			</div>
		</div>
	);
}
